export default "__VITE_ASSET__baN7jJic__"